import { render } from "./IdeA.vue?vue&type=template&id=50c945e4"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/IdeA.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50c945e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50c945e4', __exports__)) {
    api.reload('50c945e4', __exports__)
  }
  
  module.hot.accept("./IdeA.vue?vue&type=template&id=50c945e4", () => {
    api.rerender('50c945e4', render)
  })

}


export default __exports__